<template>
  <el-container>
    <el-header height="70px">
      <h1>远腾经销系统</h1>
      <el-dropdown trigger="click">
        <el-button type="primary">
          <div class="user_info">
            <div class="img_profile">
              <img src="../assets/head.jpg" alt="" class="profilePicture">
            </div>
            <div class="info_content">
              <span style="color: #eeeeee">{{ username }}</span>
              <i class="el-icon-d-caret"></i>
            </div>
          </div>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="updateInfo">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </el-header>
    <el-container class="report-nav">
      <el-aside>
        <el-row>
          <el-col :span="24">
            <el-menu
              route
              :default-active="activeIndex"
              @select="handleMenuClick"
              :collapse="isCollapse"
              class="el-menu-vertical-demo"
              text-color="#272727"
              active-text-color="#2780d1">
              <el-menu-item index="/index/home">
                <i class="el-icon-edit"></i>
                <span slot="title">首页</span>
              </el-menu-item>
              <el-menu-item index="/index/customer">
                <i class="el-icon-user"></i>
                <span slot="title">客户中心</span>
              </el-menu-item>
              <el-menu-item index="/index/review">
                <i class="el-icon-circle-check"></i>
                <span slot="title">待审核列表</span>
              </el-menu-item>
              <el-menu-item index="/index/findCustomer">
                <i class="el-icon-document"></i>
                <span slot="title">客户查询</span>
              </el-menu-item>
              <el-menu-item index="/index/dealer" v-if="userRole">
                <i class="el-icon-suitcase-1"></i>
                <span slot="title">经销商</span>
              </el-menu-item>
              <el-menu-item index="/index/account" v-if="userRole">
                <i class="el-icon-tickets"></i>
                <span slot="title">账户列表</span>
              </el-menu-item>
              <el-menu-item index="/index/addExpress" v-if="userRole">
                <i class="el-icon-takeaway-box"></i>
                <span slot="title">快递新增</span>
              </el-menu-item>

            </el-menu>
          </el-col>
        </el-row>
        <!--        <el-divider direction="vertical" style="right: 0"></el-divider>-->
      </el-aside>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      user: localStorage.getItem("access-admin") ? JSON.parse(localStorage.getItem("access-admin")) : {},
      username: '',
      activeIndex: this.$route.path,
      userRole: false,
      isCollapse: true
    }
  },
  methods: {
    handleClick() {

    },
    handleMenuClick(index) {
      // console.log(index);
      this.activeIndex = index;
      this.$router.push(index);
    },
    logout() {
      localStorage.removeItem("access-admin");
      this.$router.push('/login')
    },
    updateInfo() {
      this.$router.push('modify');
    },
    handleResize() {
      if (window.innerWidth < 768) {
        this.isCollapse = true;
      } else {
        this.isCollapse = false;
      }
    },
    handleFocus() {
      let data = localStorage.getItem("access-admin") ? JSON.parse(localStorage.getItem("access-admin")) : {};
      if (this.username !== decodeURIComponent(window.atob(data.username))) {
        window.location.reload();
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('focus', this.handleFocus);
  },
  mounted() {
    window.addEventListener('focus', this.handleFocus);
  },
  created() {
    this.activeIndex = this.$route.path;
    if (this.user == null) {
      this.$alert('请先去登录', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          this.$router.push('/login')
        }
      });
    }
    this.userRole = decodeURIComponent(window.atob(this.user.role)) == "ADMIN"
    const username = (JSON.parse(window.localStorage.getItem("access-admin"))).username || '';
    this.username = decodeURIComponent(window.atob(username));
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.activeIndex = val.path;
        // console.log(val.path);
      },
    }
  }
}
</script>

<style scoped>
.el-container {
  width: 100%;
}

.report-nav {
  min-height: calc(100vh - 70px - 65px);
}

.el-header {
  background-color: #216cb0;
  display: flex;
}

/deep/ .el-aside {
  max-width: 200px !important;
}

h1 {
  font-size: 30px;
  color: white;
  font-weight: initial;
  line-height: 30px;
  font-family: Bahnschrift;
  width: 90%;
}

/*右上角用户信息*/
.user_info {
  height: 35px;
  margin: auto;
  display: flex;
  padding: 1px 4px;
}

.info_content {
  margin: auto;
  color: #dfe2df;
  padding: 0 4px;
}

.img_profile {
  /*border: 1px solid #c9ccc9;*/
  width: 26px;
  height: 26px;
  margin: auto;
  text-align: center;
  margin-right: 1px;
}

/*头像*/
.profilePicture {
  width: 25px;
  height: 25px;
  margin: auto;
}

.el-dropdown {
  vertical-align: center;
  margin: auto;
}

.el-button {
  margin: 0;
  padding: 0 2px;
  background-color: #257ac7;
  border-color: #257ac7;
}

.el-button:hover {
  background-color: #2780d1;
}

/*侧边栏*/
.el-menu-item {
  background-color: #f7f7f7;
  margin: 7px 10px;
  height: 40px;
  line-height: 40px;
}

@media screen and (max-width: 768px) {
  /deep/ .el-aside {
    width: auto !important;
  }

  /deep/ .el-tooltip {
    padding: 0 10px !important;
  }

}

@media screen and (max-width: 385px) {
  .el-main {
    padding: 10px 10px;
  }
}

@media screen and (max-width: 325px) {
  h1 {
    font-size: 25px;
    line-height: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue